if (!customElements.get('hongteya-loop-video')) {
  customElements.define('hongteya-loop-video', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.button = this.querySelector('[data-video-toggle]');
      this.videoHost = this.querySelector('[data-video-slot]');
      this.template = this.querySelector('template');
      if (!this.button || !this.videoHost || !this.template) return;
      this.visible = false;
      this.userPaused = false;
      this.manualPlayback = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.video = this.videoHost.querySelector('video');
      if (this.video) this.bindVideo();
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        if (this.video && !this.video.paused) {
          this.userPaused = true;
          this.video.pause();
        } else {
          this.manualPlayback = true;
          this.userPaused = false;
          this.mountVideo();
          this.playVideo();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      this.motion.addEventListener('change', () => this.syncPlayback(), options);
      this.connection?.addEventListener('change', () => this.syncPlayback(), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.syncPlayback();
        }, { threshold: 0.01 });
        this.observer.observe(this);
      }
    }

    canAutoplay() {
      return this.manualPlayback || (!this.motion.matches && !this.connection?.saveData);
    }

    syncPlayback() {
      if (this.visible && !document.hidden && !this.userPaused && this.canAutoplay()) {
        this.mountVideo();
        this.playVideo();
      } else {
        this.video?.pause();
      }
    }

    mountVideo() {
      if (this.video) return;
      this.videoHost.appendChild(this.template.content.cloneNode(true));
      this.video = this.videoHost.querySelector('video');
      if (!this.video) return;
      this.video.muted = true;
      this.video.playsInline = true;
      this.bindVideo();
    }

    bindVideo() {
      const options = { signal: this.events.signal };
      this.video.addEventListener('playing', () => {
        this.setAttribute('data-ready', '');
        this.button.setAttribute('aria-pressed', 'true');
      }, options);
      this.video.addEventListener('pause', () => {
        this.button.setAttribute('aria-pressed', 'false');
      }, options);
      this.video.addEventListener('error', () => {
        this.removeAttribute('data-ready');
        this.button.setAttribute('aria-pressed', 'false');
      }, options);
    }

    playVideo() {
      if (!this.video || !this.video.paused) return;
      this.video.play().then(() => {
        if (!this.isConnected || document.hidden || this.userPaused || (!this.visible && 'IntersectionObserver' in window)) {
          this.video.pause();
        }
      }).catch(() => {
        if (this.video.paused) this.button.setAttribute('aria-pressed', 'false');
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.video?.pause();
    }
  });
}
